import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import {
  Wrapper,
  PageContent,
  Title,
  TitleWrapper,
  PlaceholderWrapper,
  LeftFields,
  Input,
  InputWrapper,
  InputErrorMessage,
  InputYearsExperience,
  CountryCityWrapper,
  SelectWrapper,
  RightFields,
  SignUpButton,
  SignUpButtonWrapper,
  SignInLinkerWrapper,
  Text,
  Anchor,
  Spinner,
} from './SignUpPage.style';

import Placeholder from '../../../components/Placeholder';
import { TABLET_L } from '../../../constants';

const CountryCityInnerInputWrapper = InputWrapper.extend`
  margin: 0;

  > div,
  input {
    height: 36px;
    line-height: 36px;
  }
`;

const SignUpForm2 = ({
  auth,
  copy,
  givenName,
  familyName,
  country,
  city,
  jobTitle,
  yearsExperience,
  locale,
  password,
  passwordMatch,
  email,
  onInputChange,
  onSignUp,
  isValidSignUpForm,
  loading,
  error,
  forgotPassword,
  copyold,
  inputValidationError,
}) => (
  <Wrapper>
    <PageContent>
      <TitleWrapper>
        {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
          <Title>{copy.signUp}</Title>
        ) : (
          <Placeholder h="40px" w={window.innerWidth > TABLET_L ? '500px' : '100%'} />
        )}
      </TitleWrapper>
      <form onSubmit={onSignUp}>
        <LeftFields>
          <InputWrapper>
            <Input
              type="text"
              placeholder={copy.givenNamePlaceholder}
              value={givenName}
              onChange={onInputChange('givenName')}
            />
            {inputValidationError &&
              inputValidationError.givenName && <InputErrorMessage>{inputValidationError.givenName}</InputErrorMessage>}
          </InputWrapper>
          <InputWrapper>
            <Input
              type="text"
              placeholder={copy.familyNamePlaceholder}
              value={familyName}
              onChange={onInputChange('familyName')}
            />
            {inputValidationError &&
              inputValidationError.familyName && (
                <InputErrorMessage>{inputValidationError.familyName}</InputErrorMessage>
              )}
          </InputWrapper>
          <CountryCityWrapper>
            <CountryCityInnerInputWrapper>
              <SelectWrapper>
                <select onChange={onInputChange('country')} value={country || 'Country'}>
                  <option value="Country" disabled>
                    {copy.country}
                  </option>
                  <option value="Japan">{copyold.japan}</option>
                  <option value="Taiwan">{copyold.taiwan}</option>
                  <option value="Hong Kong">{copyold.hongKong}</option>
                  <option value="Indonesia">{copyold.indonesia}</option>
                  <option value="Malaysia">{copyold.malaysia}</option>
                  <option value="Korea">{copyold.korea}</option>
                  <option value="Thailand">{copyold.thailand}</option>
                  <option value="Singapore">{copyold.singapore}</option>
                  <option value="China">{copyold.china}</option>
                </select>
              </SelectWrapper>
              {inputValidationError &&
                inputValidationError.country && <InputErrorMessage>{inputValidationError.country}</InputErrorMessage>}
            </CountryCityInnerInputWrapper>
            <CountryCityInnerInputWrapper>
              <Input type="text" placeholder={copy.city} value={city} onChange={onInputChange('city')} />
              {inputValidationError &&
                inputValidationError.city && <InputErrorMessage>{inputValidationError.city}</InputErrorMessage>}
            </CountryCityInnerInputWrapper>
          </CountryCityWrapper>

          <InputWrapper>
            <Input
              type="text"
              placeholder={copy.jobTitlePlaceholder}
              value={jobTitle}
              onChange={onInputChange('jobTitle')}
            />
            {inputValidationError &&
              inputValidationError.jobTitle && <InputErrorMessage>{inputValidationError.jobTitle}</InputErrorMessage>}
          </InputWrapper>
          <InputWrapper>
            <InputYearsExperience
              type="text"
              placeholder={copy.yearsExperiencePlaceholder}
              value={yearsExperience}
              onChange={onInputChange('yearsExperience')}
            />
            {inputValidationError &&
              inputValidationError.yearsExperience && (
                <InputErrorMessage>{inputValidationError.yearsExperience}</InputErrorMessage>
              )}
          </InputWrapper>
        </LeftFields>
        <RightFields>
          <InputWrapper>
            <Input
              type="email"
              placeholder={forgotPassword.emailPlaceholder}
              value={email}
              onChange={onInputChange('email')}
            />
            {inputValidationError &&
              inputValidationError.email && <InputErrorMessage>{inputValidationError.email}</InputErrorMessage>}
          </InputWrapper>
          <InputWrapper>
            <Input
              type="password"
              placeholder={forgotPassword.passwordPlaceholder}
              value={password}
              onChange={onInputChange('password')}
            />
            {inputValidationError &&
              inputValidationError.password && <InputErrorMessage>{inputValidationError.password}</InputErrorMessage>}
          </InputWrapper>
          <InputWrapper>
            <Input
              type="password"
              placeholder={copy.passwordMatchPlaceholder}
              value={passwordMatch}
              onChange={onInputChange('passwordMatch')}
            />
            {inputValidationError &&
              inputValidationError.passwordMatch && (
                <InputErrorMessage>{inputValidationError.passwordMatch}</InputErrorMessage>
              )}
          </InputWrapper>

          {error && <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>}
          <SignUpButtonWrapper>
            {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
              <SignUpButton type="submit" disabled={!isValidSignUpForm() || loading}>
                {loading ? <Spinner /> : copy.signUp}
              </SignUpButton>
            ) : (
              <PlaceholderWrapper>
                <Placeholder h="65px" w="100%" />
              </PlaceholderWrapper>
            )}
          </SignUpButtonWrapper>
          <SignInLinkerWrapper>
            {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
              <React.Fragment>
                <Text>{copy.alreadyHaveAccount}</Text>
                <Link to={`/${locale}/salon-consultation/login`} href={`/${locale}/salon-consultation/login`}>
                  <Anchor>{copy.signIn}</Anchor>
                </Link>
              </React.Fragment>
            ) : (
              <Placeholder h="25px" w="260px" />
            )}
          </SignInLinkerWrapper>
        </RightFields>
      </form>
    </PageContent>
  </Wrapper>
);

SignUpForm2.defaultProps = {
  copy: {},
  loading: false,
  error: '',
};

SignUpForm2.propTypes = {
  copy: PropTypes.shape({}),
  forgotPassword: PropTypes.shape({}).isRequired,
  copyold: PropTypes.shape({}).isRequired,
  givenName: PropTypes.string.isRequired,
  familyName: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  yearsExperience: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  passwordMatch: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onSignUp: PropTypes.func.isRequired,
  isValidSignUpForm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

export default SignUpForm2;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SignUpPage/SignUpForm2.js